import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { getPolicyCategoryList, removePolicyCategory } from "../../../services/ApiService";
import { api } from "../../../utils/api";
import { promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import CustomTable from "../../components/CustomTable";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const QuestionairList = (props) => {
    const lang = props.lang;
    const history = useHistory();
    const location = useLocation();
    const tableColumns = [
        {
            Header: translate(lang, 'index'),
            accessor: (row, index) => {
                return index + 1;
            }
        },
        {
            Header: translate(lang, 'policyCategoryName'),
            accessor: (row, index) => {
                return row.name;
            }
        },
        {
            Header: translate(lang, 'masterPolicy'),
            accessor: (row, index) => {
                return row.policy_master.name;
            }
        },
        // {
        //     Header: translate(lang, 'totalSteps'),
        //     accessor: (row, index) => {
        //         return row.policy_master.name;
        //     }
        // },
        {
            Header: translate(lang, 'totalQuestions'),
            accessor: (row, index) => {
                return row.policy_master.name;
            }
        },
        {
            Header: translate(lang, 'action'),
            accessor: (row, index) => {
                return (<>
                    <div className="row">
                        <Link
                            to={`/questionair/edit/${row.slug}`}
                            className="btn btn-primary shadow btn-xs sharp me-1"
                        >
                            <i className="fas fa-eye"></i>
                        </Link>
                    </div>
                </>)
            }
        },
    ]
    const [data, setData] = useState([]);
    const [fileData, setFileData] = useState({
        name: "member_list_report",
        excelData: [],
        hasCustom: false,
        customRows: [{
            customData: [],
            origin: -1, // last row or specified location like 'A1'
        }],
    });

    useEffect(() => {
        getList()
    }, [])

    async function getList() {
        let query = {};
        let res = await getPolicyCategoryList(query);
        if (res?.status === 'success') {
            // let temp = res.data.map(q => ({...q, questionairs: [...q.questionairs, q.questionairs[0].] }));
            setData([...res.data])
            setFileData([...res.data])
        } else {
        }
    }

    function removeItem(id) {
        Swal.fire({
            title: translate(props.lang,"delete"),
            text: translate(props.lang,"deleteMessage"),
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            dangerMode: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await removePolicyCategory(id)
                if (res.status === 'success') {
                    promptMessage(lang, 'success', res.message)
                    getList();
                } else {
                    promptMessage(lang, 'error', res.message)
                    getList();
                }
            } 
        })
    }

    return (
        <>
            <div className="card shadow">
                <div className="card-header">
                    <div>
                        <h3>{translate(props.lang, "questionnaireList")}</h3>
                        {/* <Link to="/settings/policy-category/create" className="btn btn-primary btn-sm">{translate(lang, 'createPolicyCategory')}</Link> */}
                    </div>
                </div>
                <div className="card-body">
                    <div id="job_data" className="dataTables_wrapper">
                        <CustomTable
                            lang={props.lang}
                            columns={tableColumns}
                            data={data}
                            excelExport={true}
                            fileData={fileData}
                            history={history}
                            location={location}
                        ></CustomTable>
                    </div>
                </div>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(QuestionairList);